import { useTranslation } from 'react-i18next';
import { CgProfile } from 'react-icons/cg';

import { ContentCard } from '../../layout/ContentCard';
import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import PersonalSettingsForm from './PersonalSettingsForm';

const PersonalSettingsFormPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('user:personal_settings.title')} />
      <ContentCard header={t('user:personal_settings.title')} maxWidth={{ base: 'full', xl: '100%' }} icon={<CgProfile size="40" />}>
        <PersonalSettingsForm />
      </ContentCard>
    </ContentLayout>
  );
};

export default PersonalSettingsFormPage;
